<template>
<!-- 左边菜单栏 -->
	<div class="container">
    <!-- logo -->
    <div class="menu-bar-container">
      <div v-if="!collapse" class="logo">
          <img id="logo" src="@/assets/head_logo.png"/>
      </div>
      <div v-if="collapse" class="logo-collapse">
          <!-- <img id="logo-collapse" src="@/assets/logo.png"/> -->
      </div>
    </div>
    <!-- 导航菜单 -->
    <el-menu ref="navmenu" :default-active="activeIndex" background-color="#768c95" active-text-color="#ffd04b" text-color="#fff"
      :unique-opened="true" @open="handleopen" @close="handleclose" @select="handleselect"
      :class="collapse?'menu-bar-collapse-width':'menu-bar-width'" :collapse="collapse" :collapse-transition="false">
      <!-- 导航菜单树组件，动态加载菜单 -->
      <menu-tree v-for="item in navTree" :key="item.id" :menu="item"></menu-tree>
    </el-menu>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import MenuTree from "@/components/MenuTree"
export default {
  data() {
    return {
      // 初始化就激活当前的菜单
      activeIndex: ""
    };
  },
  components:{
    MenuTree
  },
  computed: {
    ...mapState({
      navTree: state=>state.menu.navTree,
      activeMenu: state=>state.menu.activeMenu,
      collapse: state=>state.app.collapse,
    }),
  },
  watch: {
    $route: 'handleRoute'
  },
  created() {
    // 刷新页面之前把activeMenu写入localStorage
    window.addEventListener("beforeunload", () => {
      localStorage.activeMenu = this.activeMenu
    })
    if (this.$route.meta.title == "首页") {
      this.activeIndex = '1'
    } else if (this.$route.meta.displayStatus == '2') {
      this.activeIndex = this.activeMenu
    } else {
      this.activeIndex = this.$route.meta.index.toString()
    }
  },
  methods: {
    handleopen(key, keyPath) {
      // console.log('handleopen')
    },
    handleclose(key, keyPath) {
      // console.log('handleclose')
    },
    handleselect(key, keyPath) {
      // console.log('handleselect')
    },
    // 路由操作处理
    handleRoute (route) {
      // tab标签页选中, 如果不存在则先添加
      // var tab = this.mainTabs.filter(item => item.name === route.name)[0]
      // if (!tab) {
      //   tab = {
      //     name: route.name,
      //     title: route.name,
      //     icon: route.meta.icon
      //   }
      //   this.mainTabs = this.mainTabs.concat(tab)
      // }
      // this.mainTabsActiveName = tab.name
      // 切换标签页时同步更新高亮菜单
      // if(this.$refs.navmenu != null) {
      //   this.$refs.navmenu.activeIndex = '' + route.meta.index
      //   this.$refs.navmenu.initOpenedMenu()
      // }
      if (this.$route.meta.title == "首页") {
        this.activeIndex = '1'
      } else if (this.$route.meta.displayStatus == '2') {
        this.activeIndex = this.activeMenu
      } else {
        this.activeIndex = this.$route.meta.index.toString()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  position:fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  .menu-bar-container {
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    z-index: 1020;
    .logo {
      position:absolute;
      top: 0px;
      height: 58px;
      width: 251px;
      border-width: 1px;
      border-style: solid none solid solid;
      border-color: rgba(121, 121, 121, 1);
      background-color: rgba(251, 251, 251, 1);
      #logo {
        width: 252px;
        height: 58px;
      }
    }
    .logo-collapse {
      position:absolute;
      top: 0px;
      height: 58px;
      width: 59px;
      border-width: 1px;
      border-style: solid none solid solid;
      border-color: rgba(121, 121, 121, 1);
      background-color: rgba(251, 251, 251, 1);
      // #logo-collapse {
      //   width: 58px;
      //   height: 58px;
      // }
    }
  }
  .el-menu {
    position:absolute;
    // width: 252px;
    top: 60px;
    bottom: 0px;
    text-align: left;
  }
  .menu-bar-width {
    width: 201.6px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display:none; /* 兼容Chrome、Safari */
    }
    scrollbar-width: none; /* 兼容Firefox */
  }
  .menu-bar-collapse-width {
    width: 60px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display:none; /* 兼容Chrome、Safari */
    }
    scrollbar-width: none; /* 兼容Firefox */
  }
}
.el-menu-item {
  display: flex;
  align-items: center;
  white-space: normal;
}
>>> .el-submenu__title {
  display: flex;
  align-items: center;
  white-space: normal;
}
>>> .el-submenu .el-menu-item {
  padding-right: 20px;
  display: flex;
  align-items: center;
  white-space: normal;
}
>>> .el-submenu__icon-arrow {
  right: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/NavBar/NavBar.vue